<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Tabs/other'
 * Name: Checkbox
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=40-5981&t=ldymHtYK0zJDKBqF-4
 */
import type { BtnCheckboxProps } from '../types/interfaces'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { TooltipPrimary } from '@shared/ui/tooltips'
import { IconContainer } from '@shared/ui/other'

import { useBtnCheckbox } from '../composables/use-btn-checkbox.hook'

defineOptions({
  name: 'BtnCheckbox',
})

const props = withDefaults(defineProps<BtnCheckboxProps>(), {
  checked: false,
  disabled: false,
  required: false,
  tooltipText: '',
  mode: 'normal',
  errorText: 'This field must be filled',
  text: '',
})

const emit = defineEmits<{
  click: []
}>()

const {
  refIsError,
  isChecked,
  handleClick,
} = useBtnCheckbox({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <div :class="['ui-checked-container', { tooltip: !!tooltipText }]">
    <button
      :class="['checkbox', { 'checked': checked, disabled }]"
      :disabled="disabled"
      :aria-label="label || undefined"
      :aria-pressed="checked"
      @click="handleClick"
    >
      <IconContainer
        class="checkbox__icon"
      >
        <FontAwesomeIcon
          :icon="isChecked(checked)"
        />
      </IconContainer>
      <AppText
        v-if="text"
        name="body1"
        class="checkbox__label"
      >
        <span v-html="text" />
        <span
          v-if="required"
          class="checked__required"
        >*</span>
      </AppText>
      <slot v-else />
    </button>
    <AppText
      v-if="refIsError"
      name="body2"
      color="red-500"
      class="checked__error"
    >
      {{ errorText }}
    </AppText>
    <TooltipPrimary
      :text="tooltipText"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_btn-checkbox.scss" />
